import React from 'react';
import Swal from 'sweetalert2';
import { Toggle } from '../../../../components/Toggle/Toggle';
import { useTheme } from '../../../../contexts/Theme/ThemeContext';
import { ConfiguracoesAvancadasContainer, Botoes } from './styles';
import Titulo from '../../../../components/Modal/ModaisConfigsPrimeiroAcesso/Titulo/Titulo';
import { ReactComponent as Voltar } from "../../../../assets/newImages/icons/angle-down.svg";
import Modal from '../../../../components/Modal/Modal';

interface ConfigsAvancadasProps {
  isOpen: boolean;
  onClose: () => void;
  apagarImagensExistentes: boolean;
  setApagarImagensExistentes: (value: boolean) => void;
}

const ConfigsAvancadas: React.FC<ConfigsAvancadasProps> = ({
  isOpen,
  onClose,
  apagarImagensExistentes,
  setApagarImagensExistentes,
}) => {
  const { theme } = useTheme();

  const handleToggleChange = (newValue: boolean) => {
    if (newValue) {
      Swal.fire({
        title: "Apagar imagens existentes?",
        text: "Ao habilitar essa opção, todas as imagens já cadastradas nos produtos serão removidas.",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        confirmButtonText: "Apagar Imagens",
        customClass: {
          confirmButton: 'btn-confirm',
          icon: 'custom-swal-icon',
        },
      }).then((result) => {
        if (result.isConfirmed) {
          setApagarImagensExistentes(newValue);
        } else {
          setApagarImagensExistentes(false);
        }
      });
    } else {
      setApagarImagensExistentes(newValue);
    }
  };

  return (
    <Modal
      width={"60rem"}
      maxWidth="98vw"
      isOpen={isOpen}
      backdrop={"static"}
      setModal={onClose}
    >
      <ConfiguracoesAvancadasContainer theme={theme}>
        <Titulo
          titulo="Apagar imagens existentes"
          subtitulo="Atenção, essa ação é irreversível."
          flexDirection="column-reverse"
        />
        <div className="remover-imagens">
          <label className="fonteTexto">
            <Toggle
              value={apagarImagensExistentes}
              onChange={handleToggleChange}
            />
            Apagar imagens existentes do produto
          </label>
          <p className="texto fonteRotulos">
            <strong>
              Se habilitada essa opção, todas as imagens já cadastradas<br /> nos produtos serão removidas antes de importar as novas.
            </strong>
          </p>
        </div>
        <Botoes theme={theme}>
          <div
            className='cancelar'
            title='Voltar'
            onClick={onClose}
          >
            <Voltar /> Voltar
          </div>
        </Botoes>
      </ConfiguracoesAvancadasContainer>
    </Modal>
  );
};

export default ConfigsAvancadas;
